import axios from "axios";
import { API_BASE_URL } from "../utils/AppConstants";

const SITE_IMAGES_URL = `${API_BASE_URL}site-images/`;

export const fetchSiteImages = async () => {
  const res = await axios.get(SITE_IMAGES_URL);
  return res.data;
};
